import React from 'react';
import { Icons, IconButton } from "@curves/ui-base";
import { useHistory } from 'react-router-dom';
import { CLUB_POS_ROUTER } from '@icoach/router/routerPath';

const PosBox = () => {
    const history = useHistory();
    const handlePosOnClick = () => {
        history.push(CLUB_POS_ROUTER.BASE);
    };
    return (
        <IconButton onClick={handlePosOnClick}>
            <Icons.PosIncome htmlColor="white" />
        </IconButton>
    );
};

export default PosBox;
